/**
 * @generated SignedSource<<6f509aaeffa93e9140e4fc9a10ef783a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type utils_getRecordingLinkQuery$variables = {
  noteId: string;
  recordingId?: string | null;
};
export type utils_getRecordingLinkQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly meetingRecordingLink?: {
      readonly url: string;
    };
  } | null;
};
export type utils_getRecordingLinkQuery = {
  response: utils_getRecordingLinkQuery$data;
  variables: utils_getRecordingLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recordingId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "forCopy",
      "value": true
    },
    {
      "kind": "Variable",
      "name": "recordingId",
      "variableName": "recordingId"
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "utils_getRecordingLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingLink",
                "kind": "LinkedField",
                "name": "meetingRecordingLink",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "utils_getRecordingLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingLink",
                "kind": "LinkedField",
                "name": "meetingRecordingLink",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "06432a3005baf798ede43468e1110fb9",
    "id": null,
    "metadata": {},
    "name": "utils_getRecordingLinkQuery",
    "operationKind": "query",
    "text": "query utils_getRecordingLinkQuery(\n  $noteId: ID!\n  $recordingId: ID\n) {\n  node(id: $noteId) {\n    __typename\n    ... on Note {\n      id\n      meetingRecordingLink {\n        url(forCopy: true, recordingId: $recordingId)\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f10d9c3949348e08a2adb4e5b6803933";

export default node;
